import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Col, Row } from "reactstrap"
import Image from "gatsby-image"
import { Header, Works, Accordian } from "../components/leads"
import SEO from "../components/seo"

const SCOUT_SCRIPT_SRC = "https://d1bhoz8vz21659.cloudfront.net/scout-widget.js"

export default class Template extends React.Component {
  constructor(props) {
    super(props)
    this.ref = React.createRef()
    this.state = {
      collapse: false,
    }
  }

  componentDidMount = () => {
    this.loadRedTrack()
    this.loadFraudBlocker()
  }

  loadFraudBlocker = () => {
    var s = document.createElement("script"),
      h = document.head
    s.async = 1
    s.src = "https://monitor.fraudblocker.com/fbt.js?sid=sVIntzCVLKWlaR_PgxcDy"
    h.appendChild(s)
  }

  loadScout = (scoutEmbedID, scoutSourceID) => {
    const container = document.getElementById("widget-1")
    if (!container || !scoutEmbedID || !scoutSourceID) {
      return
    }

    const initialize = () => {
      if (
        !window.scoutWidget ||
        typeof window.scoutWidget.Initialize !== "function"
      ) {
        return false
      }
      window.scoutWidget.Initialize(container, {
        id: String(scoutEmbedID),
        sourceId: String(scoutSourceID),
        test: process.env.NODE_ENV !== "production",
        onConversion: () => {
          console.log("In scout onConversion")
          if (window.dataLayer) {
            console.log("In scout onConversion datalayer check")
            window.dataLayer.push({ event: "bzConversion" })
          }
        },
      })
      return true
    }

    const waitForScout = () => {
      if (initialize()) {
        return
      }
      let attempts = 0
      const interval = setInterval(() => {
        attempts += 1
        if (initialize() || attempts > 50) {
          clearInterval(interval)
        }
      }, 100)
    }

    if (window.scoutWidget) {
      initialize()
      return
    }

    const existing = document.querySelector(`script[src="${SCOUT_SCRIPT_SRC}"]`)
    if (existing) {
      waitForScout()
      return
    }

    const script = document.createElement("script")
    script.src = SCOUT_SCRIPT_SRC
    script.type = "module"
    script.crossOrigin = "anonymous"
    script.onload = waitForScout
    document.head.appendChild(script)
  }

  loadRedTrack = () => {
    let params = new URLSearchParams(window.location.search)
    const rtClickID = params.get("rtClickID")
    const {
      markdownRemark: {
        frontmatter: { scoutEmbedID, scoutSourceID } = {},
      } = {},
    } = this.props.data
    window.rtkClickID = rtClickID
    this.setCookie("rtkclickid-store", rtClickID)
    this.loadScout(scoutEmbedID, scoutSourceID)
  }

  setCookie = (name, value) => {
    var expires = ""
    var date = new Date()
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toUTCString()
    document.cookie =
      name +
      "=" +
      (value || "") +
      expires +
      `; ${window.location.origin.split("://")[1]}` +
      "; path=/"
  }

  scrollandCollapse = collapse => {
    this.setState({
      ...this.state,
      collapse,
    })
  }

  render() {
    let frontmatter = {},
      html = "",
      image = ""
    if (this.props.data !== null && this.props.data.markdownRemark !== null) {
      frontmatter = this.props.data.markdownRemark.frontmatter
      image = this.props.data.markdownRemark.frontmatter.image.childImageSharp
      html = this.props.data.markdownRemark.html
    }
    const scrollDown = this.ref
    return (
      <Layout>
        <SEO title={frontmatter.categoryName} />
        <Header
          title={frontmatter.title}
          scrollDown={scrollDown}
          scrollandCollapse={this.scrollandCollapse}
        />
        <Row style={{ marginTop: -20 }} className="d-none d-lg-block mb-5">
          <Col xs={8} className="pt-3 pb-5 d-flex justify-content-center">
            <Image
              fluid={image.fluid}
              style={{ width: 400, marginLeft: -100 }}
            />
          </Col>
        </Row>
        <Works />
        <div ref={scrollDown}>
          <Accordian
            scrollandCollapse={this.scrollandCollapse}
            scrollCollapse={this.state.collapse}
            html={html}
            articleHeading={frontmatter.articleHeading}
          />
        </div>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query($searchQuery: String!) {
    markdownRemark(frontmatter: { path: { eq: $searchQuery } }) {
      html
      frontmatter {
        categoryName
        title
        articleHeading
        scoutSourceID
        scoutEmbedID
        image {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
